import Image from "next/image";
import DsButton from "@components/services/DsButton";

interface CaseMetric {
  value: string;
  label: string;
}

interface CaseStudyCardProps {
  tag: string;
  title: string;
  quote: string;
  image: string;
  imageAlt: string;
  metrics: CaseMetric[];
  cta?: {
    label: string;
    href: string;
  };
}

export default function CaseStudyCard({
  tag,
  title,
  quote,
  image,
  imageAlt,
  metrics,
  cta,
}: CaseStudyCardProps) {
  return (
    <article className="case">
      <div className="case-photo">
        <Image
          src={image}
          alt={imageAlt}
          fill
          sizes="(max-width: 880px) 100vw, 38vw"
          style={{ objectFit: "cover", objectPosition: "center top" }}
          loading="lazy"
        />
      </div>
      <div className="case-body">
        <span className="case-tag">{tag}</span>
        <h3>{title}</h3>
        <blockquote>{quote}</blockquote>
        {cta ? (
          <div className="case-actions">
            <DsButton href={cta.href} label={cta.label} variant="primary" />
          </div>
        ) : null}
        <div className="case-metrics">
          {metrics.map((metric) => (
            <div className="cm" key={metric.label}>
              <span className="v">{metric.value}</span>
              <span className="k">{metric.label}</span>
            </div>
          ))}
        </div>
      </div>
    </article>
  );
}
